import { AnimatePresence } from 'framer-motion';
import React from 'react';
export function ChecklistCollection({ children }) {
    return React.createElement(AnimatePresence, { initial: false }, children);
}
